import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

const Error = ({ children, classes }) => (
    <div className={classes.wrapper}>{children}</div>
);

Error.propTypes = {
    children: PropTypes.node,
};

Error.defaultProps = {
    children: undefined,
};

const style = ({ palette }) => ({
    wrapper: {
        color: palette.error.main,
    },
});

export default injectSheet(style)(Error);



// WEBPACK FOOTER //
// ./src/components/Error.js